import type { TransferDetail } from '@/features/requests/types/transferRequest'
import { apiClient } from '@/lib/api/api-client'
import type { ItemLogUsage } from '@/types/itemLogUsage'
import { LogEntry } from '@/types/log'
import { ItemDetail, ItemsResponse } from '../types/item'

export const itemApi = {
  getItems: (params?: { status?: string; productId?: string; departmentId?: string; excludeDepartmentId?: string }) => {
    return apiClient.get<ItemsResponse>('items', { params })
  },

  getItem: (id: string) => {
    return apiClient.get<ItemDetail>(`items/${id}`)
  },

  getItemTransfer: (id: string) => {
    return apiClient.get<TransferDetail>(`items/${id}/transfer`)
  },

  createItem: (productId: string, payload: any) => {
    return apiClient.post<ItemDetail>(`products/${productId}/items`, payload)
  },

  updateItem: (id: string, payload: any) => {
    return apiClient.put<ItemDetail>(`items/${id}`, payload)
  },

  updateItemStatus: (id: string, payload: { status: string; note?: string }) => {
    return apiClient.patch<ItemDetail>(`items/${id}/status`, payload)
  },

  getItemLogs: (id: string) => {
    return apiClient.get<LogEntry[]>(`items/${id}/logs`)
  },

  deleteItem: (id: string) => {
    return apiClient.delete<void>(`items/${id}`)
  },

  getItemUsage: (id: string) => {
    return apiClient.get<ItemLogUsage[]>(`items/${id}/usages`)
  },

  createItemUsage: (id: string, payload: { patientId: string; note: string }) => {
    return apiClient.post<ItemLogUsage>(`items/${id}/usages`, payload)
  },

  endItemUsage: (id: string, payload: { note?: string }) => {
    return apiClient.patch<ItemLogUsage>(`items/${id}/usages/end`, payload)
  },
}
